<template>
    <div>
        <h3>Categories
            <v-btn icon @click="refreshData">
                <v-icon>fas fa-redo-alt</v-icon>
            </v-btn><br>
            <v-btn @click="newCategory">Create Category</v-btn>
        </h3>
        <v-text-field dense v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details v-on:keyup="maybeSearch" @click:append="refreshData"></v-text-field>
        <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="id" class="elevation-0" :footer-props="{itemsPerPageOptions:[10,25,50,100]}" :loading="loading" :options.sync="options" :server-items-length="total_items">
            <template v-slot:item.id="{ item }">
                <span class="nowrap">
                    <v-btn icon @click="editCategory(item)" color="primary">
                        <v-icon>fas fa-edit</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteCategory(item)" color="red">
                        <v-icon>fas fa-trash</v-icon>
                    </v-btn>
                </span>
            </template>
            <template v-slot:item.zendesk_category_id="{ item }">
                <v-icon v-if="item.zendesk_category_id > 0">fas fa-check</v-icon>
            </template>
            <template v-slot:item.tenant_id="{ item }">
                <span v-if="getTenant(item.tenant_id)">{{ getTenant(item.tenant_id).Tenant}}</span>
            </template>
        </v-data-table>
        <v-dialog v-model="show_edit_category" width="750">
            <v-card>
                <v-card-title>Edit Category</v-card-title>
                <v-card-text>
                    <v-text-field v-model="current_category.category" label="Category"></v-text-field>
                    <q-tenant-select label="Tenant*" v-model="current_category.tenant_id"></q-tenant-select>
                    <v-checkbox label="Support Category?" v-model="current_category.support_category_ind"></v-checkbox>
                    <v-btn @click="saveCategory" color="primary">Save</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import QGenericDataTableMixin from "@/components/datatables/QGenericDataTableMixin"
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
import Tenant from '@/store/Models/Tenant'
import QTenantSelect from '@/components/utils/QTenantSelect.vue'
export default {
    name: "QCategoryDataTable",
    props: [],
    mixins: [QGenericDataTableMixin],
    data: function() { // data internal to component (not available outside)
        return {
            //use this to "preset" a filter
            filters: {},
            options: {
                'sortBy': [],
                'sortDesc': [true]
            },
            expanded: [],
            current_category: {
                id: null,
                category: null,
                tenant_id: null,
                support_category_ind: true
            },
            show_edit_category: false,
            the_data: []
        }
    },
    mounted: function() {
        this.loadData();
    },
    computed: {
        loading: function() {
            return this.data_loading;
        },
        all_data: function() {
            return this.the_data;
        },
        filter_keys: function() {
            return [];
        },
        total_items: function() {
            return this.total_num;
        },
        the_headers: function() {
            return [{
                    text: 'Category',
                    value: 'category',
                }, {
                    text: 'Tenant',
                    value: 'tenant_id',
                    align: "center"
                }, {
                    text: 'Support',
                    value: 'zendesk_category_id',
                    align: "left"
                }, {
                    text: '',
                    value: 'id',
                },

            ]
        },
    },
    methods: {
        loadData: debounce(function(opt) {
            var g = this
            this.data_loading = true
            var filters = { 'tenant_id': this.current_tenant.ID };
            QuilityAPI.getCategories(filters, this.options).then(function(json) {
                g.data_loading = false
                g.$set(g, 'the_data', json.data);
                g.total_num = json.total
            }).catch(function(err) {
                g.data_loading = false
                if (err.status == 431) {
                    g.showError(err + " You probably need to clear all your cookie and session variables and login again.")
                    return
                }
                g.showError(err.message);
            });
            this.firstPull = false;
        }, 200),
        resetForm: function() {
            this.current_category = {
                id: null,
                category: null,
                tenant_id: this.current_tenant.ID,
                support_category_ind: true
            }
        },
        newCategory: function() {
            this.resetForm();
            this.show_edit_category = true;
        },
        editCategory: function(item) {
            this.current_category = item;
            this.show_edit_category = true;
        },
        deleteCategory: function(cat) {
            var g = this
            this.data_loading = true
            QuilityAPI.deleteCategory(cat.id).then(function(json) {
                g.data_loading = false
                g.the_data.forEach(function(item, ix) {
                    if (item.id == cat.id) {
                        g.the_data.splice(ix, 1);
                    }
                })
            }).catch(function(err) {
                g.data_loading = false
                if (err.status == 431) {
                    g.showError(err + " You probably need to clear all your cookie and session variables and login again.")
                    return
                }
                g.showError(err.message);
            });
        },
        setCategory: function(cat) {
            var g = this
            var is_set = false;
            this.the_data.forEach(function(item, ix) {
                if (item.id == cat.id) {
                    is_set = true
                    g.$set(g.the_data, ix, cat)
                }
            })
            if (!is_set) {
                //wasn't found... lets push it into the data
                this.the_data.push(cat)
            }
        },
        saveCategory: function() {
            var g = this
            this.data_loading = true
            QuilityAPI.saveCategory(this.current_category).then(function(json) {
                g.data_loading = false
                if (typeof json.response != 'undefined' && json.response.clientError) {
                    g.showError(json.response.body.message);
                    return
                }
                g.setCategory(json.data);
                g.show_edit_category = false;
            }).catch(function(err) {
                g.data_loading = false
                if (err.status == 431) {
                    g.showError(err + " You probably need to clear all your cookie and session variables and login again.")
                    return
                }
                g.showError(err.message);
            });
        }
    },
    watch: {
        'current_tenant.ID': function() {
            this.$nextTick(this.loadData);
        }
    },
    components: {
        QTenantSelect
    }
}
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}
</style>